module.exports = __webpack_public_path__ + "static/media/health-coverage-letter.c605d691.svg";